'use strict';

var angularModule = angular.module('t2g.common.data-access', [
  require('./accounting').name,
  require('./appointment').name,
  require('./billing').name,
  require('./booking').name,
  require('./countryConfig').name,
  require('./customer').name,
  require('./google-sync').name,
  require('./caldav-sync').name,
  require('./mail').name,
  require('./messages').name,
  require('./payment').name,
  require('./shiftPlanning').name,
  require('./soft-plus-sync').name,
  require('./statistic').name,
  require('./subscription').name,
  require('./sync').name,
  require('./resource').name,
  require('./office').name,
  require('./user').name,
  require('./userSession').name,
  require('./tarif590').name,
]);

module.exports = angularModule;



// WEBPACK FOOTER //
// ./src/app/common/data-access/index.js